var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-video"},[_c('video',{key:_vm.videoSource,staticClass:"bg-video__content",attrs:{"muted":"","loop":"","autoplay":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoSource,"type":"video/mp4"}}),_vm._v(" Your browser is not supported! ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }